"use strict";
/*
 * Copyright 2018 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MosaicService = void 0;

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var MosaicId_1 = require("../model/mosaic/MosaicId");

var MosaicAmountView_1 = require("./MosaicAmountView");

var MosaicView_1 = require("./MosaicView");
/**
 * Mosaic service
 */


var MosaicService = /*#__PURE__*/function () {
  /**
   * Constructor
   * @param accountRepository
   * @param mosaicRepository
   */
  function MosaicService(accountRepository, mosaicRepository) {
    _classCallCheck(this, MosaicService);

    this.accountRepository = accountRepository;
    this.mosaicRepository = mosaicRepository;
  }
  /**
   * Get mosaic view given mosaicIds
   * @param mosaicIds - The ids of the mosaics
   * @returns {Observable<MosaicView[]>}
   */


  _createClass(MosaicService, [{
    key: "mosaicsView",
    value: function mosaicsView(mosaicIds) {
      var _this = this;

      return rxjs_1.of(mosaicIds).pipe(operators_1.mergeMap(function () {
        return _this.mosaicRepository.getMosaics(mosaicIds).pipe(operators_1.mergeMap(function (info) {
          return info;
        }), operators_1.map(function (mosaicInfo) {
          return new MosaicView_1.MosaicView(mosaicInfo);
        }), operators_1.toArray());
      }));
    }
    /**
     * Get mosaic amount view given mosaic array
     * @param mosaics
     * @returns {Observable<MosaicAmountView[]>}
     */

  }, {
    key: "mosaicsAmountView",
    value: function mosaicsAmountView(mosaics) {
      var mosaicIds = mosaics.map(function (mosaic) {
        return new MosaicId_1.MosaicId(mosaic.id.toHex());
      });
      return this.mosaicsView(mosaicIds).pipe(operators_1.map(function (mosaicViews) {
        var results = [];
        mosaicViews.forEach(function (view) {
          var mosaic = mosaics.find(function (m) {
            return m.id.toHex() === view.mosaicInfo.id.toHex();
          });

          if (mosaic) {
            results.push(new MosaicAmountView_1.MosaicAmountView(view.mosaicInfo, mosaic.amount));
          }
        });
        return results;
      }));
    }
    /**
     * Get balance mosaics in form of MosaicAmountViews for a given account address
     * @param address - Account address
     * @returns {Observable<MosaicAmountView[]>}
     */

  }, {
    key: "mosaicsAmountViewFromAddress",
    value: function mosaicsAmountViewFromAddress(address) {
      var _this2 = this;

      return rxjs_1.of(address).pipe(operators_1.mergeMap(function (_) {
        return _this2.accountRepository.getAccountInfo(_);
      }), operators_1.mergeMap(function (_) {
        return _this2.mosaicsAmountView(_.mosaics);
      }));
    }
  }]);

  return MosaicService;
}();

exports.MosaicService = MosaicService;